<template>
    <div>
        <div class="d-flex mt-3 justify-content-end">
            <template v-if="model.token">
                <b-button-group>
                    <b-dropdown
                        variant="outline-secondary"
                        size="sm"
                        toggle-class="px-4 lh-1"
                        text="他"
                        :disabled="isJobRunning"
                        >
                        <b-dropdown-item variant="danger" @click="connect(model.provider)">再連携</b-dropdown-item>
                        <b-dropdown-item variant="danger" @click="disconnect(model.provider)">解除</b-dropdown-item>
                    </b-dropdown>
        
                    <b-button
                        size="sm"
                        class="px-4 lh-1 btn-theme"
                        @click="sync(model.provider)"
                        :disabled="isJobRunning"
                        >
                        <small>
                            <strong>
                                候補更新
                                <br>
                                <font-awesome-icon
                                    class="fa-fw"
                                    :class="{ 'fa-spin': isJobRunning, }"
                                    icon="sync"
                                    />
                            </strong>
                        </small>
                    </b-button>
                </b-button-group>
            </template>

            <template v-else>
                <b-button
                    size="sm"
                    class="px-4 lh-1 btn-theme"
                    type="button"
                    @click="connect(model.provider)"
                    >
                    <small>
                        <strong>
                            連携
                            <br>
                            <font-awesome-icon
                                class="fa-fw"
                                icon="link"
                                />
                        </strong>
                    </small>
                </b-button>
            </template>

        </div>

        <div
            class="text-right"
            >
            <template
                v-if="model.provider === 'ebay'"
                >
                <span v-if="model.eat">{{ model.eat | baseDatetimeFormatter }}まで連携<br>以降、再連携が必要</span>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    components: {
    },
    emits: [
        'sync',
        'disconnect',
    ],
    props: {
        model: {
            type: Object,
            required: true,
            default() {
                return {}
            },
        },
    },
    data() {
        return {}
    },
    computed: {
        ...mapGetters([
            'auth_id',
            'auth_level',
            'trans',
        ]),
        isJobRunning() {
            if (!this.model.jobs) {
                return false
            }

            return this.model.jobs['App\\Jobs\\Connector' + this.$_.capitalize(this.model.provider) + 'SyncItemCachesJob'] !== undefined
        },
    },
    async mounted() {},
    methods: {
        async sync (provider) {
            let provider_type = null
            switch (provider) {
                case 'amazon':
                    provider_type = 'inventory'
                    break
                case 'ebay':
                case 'woo':
                    provider_type = 'store'
                    break
            }

            await this.$store
                .dispatch(provider_type + '/sync_item_caches', { uuid: provider, })
                .then((response) => {
//                    this.fetch()
                    this.$emit('sync')
                })
                .catch((error) => {
                })
        },
        async connect (provider) {
            const response = await this.$store
                .dispatch('auth/redirect', provider)
        },
        async disconnect (provider) {
            const result = await this.$dialog
                .prompt({
                    title: '本当に解除しますか？',
                }, {
                    okText: '解除',
                    cancelText: 'キャンセル',
                    promptHelp: '確認のために「' + provider + '」を入力後、「[+:okText]」をクリックしてください。'
                })
                .then(async (dialog) => {
                    return dialog.data === provider
                })
                .catch(() => {
                    return false
                })

            if (! result) {
                return
            }

            const response = await this.$store
                .dispatch('auth/disconnect', provider)
                .then((response) => {
//                    this.fetch()
                    this.$emit('disconnect')
                })
                .catch((error) => {
                })
        },
    },
}
</script>

<style lang="scss" scoped></style>

